import {
  CLEAR_GROUPS,
  GROUPS_FETCHED,
  UPDATE_GROUP,
  SET_GROUPS,
  SET_GROUP_MEMBERS,
  UPDATE_LIST_CONFIG,
  DELETE_GROUP,
  GROUPS_LOADING,
} from '../../constants';
import { IReduxAction } from '../../interfaces';

import {
  approveGroupMember,
  removeGroupMember,
  createGroup,
  deleteGroup,
  getGroupMembers,
  getGroupsList,
  updateGroup,
  getFollowing,
  removeFollowing,
} from '../../../services';

import { IGroupFormData } from '../../../components/group-management';
import { IGroupListConfig } from '../reducers/groupsReducer';
import { IGroupListRepsonse } from '../../../services/interfaces/groups';

export const createGroupAction = async (user: any, group: IGroupFormData | null, dispatch: any) => {
  if (!group) {
    throw new Error('No Group Provided to Create');
  }

  await createGroup(user, group);
};

export const updateGroupAction = async (group: IGroupFormData | null, dispatch: any) => {
  if (!group) {
    throw new Error('No Group provided to update');
  }

  await updateGroup(group);

  dispatch({
    payload: group,
    type: UPDATE_GROUP,
  });
};

export const deleteGroupAction = async (groupId: string | null | undefined, dispatch: any) => {
  if (!groupId) {
    throw new Error('No Group Id provided to delete');
  }

  await deleteGroup(groupId);
  dispatch({
    payload: groupId,
    type: DELETE_GROUP,
  });
};

export const loadGroupMembers = async (groupId: string, dispatch: any) => {
  const list = await getGroupMembers(groupId);
  dispatch(setGroupMembers(list));
};

export const clearGroups = (dispatch: any) => {
  dispatch({
    payload: [],
    type: CLEAR_GROUPS,
  });
};

export const loadGroups = async (userId: string, listConfig: IGroupListConfig, dispatch: any) => {
  dispatch({
    type: GROUPS_LOADING,
  });
  dispatch(groupsFetched(true));
  const list: IGroupListRepsonse = await getGroupsList(userId, listConfig);
  const modifiedListConfig = {
    ...listConfig,
    pagination: {
      ...listConfig.pagination,
      lastItem: list.lastItem,
    },
  };
  updateListConfig(modifiedListConfig, dispatch);
  dispatch(setGroups(list.groups));
};

export const groupsFetched = (payload?: any): IReduxAction => ({
  payload,
  type: GROUPS_FETCHED,
});

export const setGroupMembers = (payload?: any): IReduxAction => ({
  payload,
  type: SET_GROUP_MEMBERS,
});

export const approveGroupMemberAction = async (groupId: string, member: any, dispatch: any) => {
  await approveGroupMember(groupId, member);
  loadGroupMembers(groupId, dispatch);
};

export const removeGroupMemberAction = async (groupId: string, member: any, dispatch: any) => {
  const followingForMember = await getFollowing(member.id);
  const followingEntry = getFollowingEntryForGroupId(groupId, followingForMember.following);
  if (followingEntry) {
    followingEntry.groups = followingEntry
      ?.groups?.filter((group: any) => group.id !== groupId) || [];
    await removeFollowing(member.id, followingEntry);
  }
  await removeGroupMember(groupId, member);
  loadGroupMembers(groupId, dispatch);
};

export const getFollowingEntryForGroupId = (groupId: string, followingList: any = []) => {
  if (followingList.length > 0) {
    for (let f = 0; f < followingList.length; f += 1) {
      const followingEntry = followingList[f];
      if (followingEntry.groups && followingEntry.groups.length > 0) {
        for (let g = 0; g < followingEntry.groups.length; g += 1) {
          const group = followingEntry.groups[g];
          if (group.id === groupId) {
            return followingEntry;
          }
        }
      }
    }
  }
  return null;
};

export const setGroups = (payload?: any): IReduxAction => ({
  payload,
  type: SET_GROUPS,
});

export const updateListConfig = (payload: any, dispatch: any) => {
  dispatch({
    payload, type: UPDATE_LIST_CONFIG,
  });
};
